<template>
  <div class="modal fade" id="GroupbuyTipModal" tabindex="-1" style="z-index:2041;" aria-labelledby="GroupbuyTipModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="Title">團購資料已傳送！</div>
        <div class="Content">1.團購單成功送達發起人介面</div>
        <div class="Content">2.改單請自行聯繫發起人做刪除</div>
        <div class="Content">3.您的介面無法查詢團購紀錄唷</div>
        <div class="modal-footer" data-bs-dismiss="modal">
          <button class="btn btn-dark" data-mdb-dismiss="modal">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "GroupbuyTipModal",
  mounted() {
    $('#GroupbuyTipModal').on('hide.bs.modal', () => { this.$router.push({ name: "Home" }) })
  },
}
</script>

<style lang="scss" scoped>
.modal {
  > .modal-dialog {
    > .modal-content {
      padding-top: 20px;
      text-align: center;
      > .Title {
        color: #5599FF;
        font-size: 24px;
        font-weight: bold;
      }
      > .Content {
        padding-top: 10px;
        font-size: 20px;
        font-weight: bold;
      }
      > div:nth-child(4) {
        padding-bottom: 20px;
      }
    }
  }
}
</style>